<template lang="pug">
.pageSuccess
  .pageSuccess__description
    svg(name="confirm-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none")
      path(fill-rule="evenodd" clip-rule="evenodd" d="M24 3C12.45 3 3 12.45 3 24C3 35.55 12.45 45 24 45C35.55 45 45 35.55 45 24C45 12.45 35.55 3 24 3ZM24 42C14.1 42 6 33.9 6 24C6 14.1 14.1 6 24 6C33.9 6 42 14.1 42 24C42 33.9 33.9 42 24 42ZM22.5 27.9L31.95 18.45C32.55 17.85 33.45 17.85 34.05 18.45C34.65 19.05 34.65 19.95 34.05 20.55L23.55 31.05C23.25 31.35 22.8 31.5 22.5 31.5C22.2 31.5 21.75 31.35 21.45 31.05L16.95 26.55C16.35 25.95 16.35 25.05 16.95 24.45C17.55 23.85 18.45 23.85 19.05 24.45L22.5 27.9Z" fill="#6320E9")
    h1.pageSuccess__text--title Seu boleto foi gerado com sucesso
    p #[b Você tem até um dia útil para efetuar o pagamento]
    p(v-html="headerText")
    p #[b Atenção:] sempre verifique a sua caixa de spam, pois o e-mail pode ser direcionado para lá.

  .pageSuccess__blockDescription
    .pageSuccess__valuesInfo
      .pageSuccess__valuesInfo--name
        svg(name="bank-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M27.0002 12.27C27.1109 11.9179 27.0186 11.5335 26.7602 11.27L18.7602 3.26999C18.5418 3.06057 18.2403 2.9613 17.9402 2.99999H8.59024C6.61024 2.99999 5.00024 4.88999 5.00024 7.21999V25.78C5.00024 28.11 6.61024 30 8.59024 30H23.4102C25.4102 30 27.0002 28.11 27.0002 25.78V12.5C27.0105 12.4237 27.0105 12.3463 27.0002 12.27ZM19.0002 6.40999L23.5902 11H20.0002C19.448 11 19.0002 10.5523 19.0002 9.99999V6.40999ZM23.4102 28H8.59024C7.74024 28 7.00024 27 7.00024 25.78V7.21999C7.00024 5.99999 7.74024 4.99999 8.59024 4.99999H17.0002V9.99999C17.0002 11.6568 18.3434 13 20.0002 13H25.0002V25.78C25.0002 27 24.2602 28 23.4102 28Z" fill="#6320E9")
          path(d="M21.0002 18H11.0002C10.448 18 10.0002 18.4477 10.0002 19C10.0002 19.5523 10.448 20 11.0002 20H21.0002C21.5525 20 22.0002 19.5523 22.0002 19C22.0002 18.4477 21.5525 18 21.0002 18Z" fill="#6320E9")
          path(d="M17.0002 22H11.0002C10.448 22 10.0002 22.4477 10.0002 23C10.0002 23.5523 10.448 24 11.0002 24H17.0002C17.5525 24 18.0002 23.5523 18.0002 23C18.0002 22.4477 17.5525 22 17.0002 22Z" fill="#6320E9")
        h2.pageSuccess__blockDescription--title Boleto
      .pageSuccess__valuesInfo--details.pageSuccess__bankSlip-btns
        a.pageSuccess__blockDescription--viewTicket(:href="url" target="_blank") Visualizar boleto
        a.pageSuccess__blockDescription--copyTicket(@click.prevent.stop="clickToCopy(digitableLine, 'bankSlipCode')")
          svg(name="copy-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none")
            path(fill-rule="evenodd" clip-rule="evenodd" d="M8.94231 8.75C8.49092 8.75 8.125 9.11592 8.125 9.56731V16.0577C8.125 16.5091 8.49092 16.875 8.94231 16.875H15.4327C15.8841 16.875 16.25 16.5091 16.25 16.0577V9.56731C16.25 9.11592 15.8841 8.75 15.4327 8.75H8.94231ZM6.875 9.56731C6.875 8.42557 7.80057 7.5 8.94231 7.5H15.4327C16.5744 7.5 17.5 8.42557 17.5 9.56731V16.0577C17.5 17.1994 16.5744 18.125 15.4327 18.125H8.94231C7.80057 18.125 6.875 17.1994 6.875 16.0577V9.56731Z" fill="#6320E9")
            path(fill-rule="evenodd" clip-rule="evenodd" d="M4.56731 4.375C4.35054 4.375 4.14266 4.46111 3.98938 4.61438C3.83611 4.76766 3.75 4.97554 3.75 5.19231V11.6827C3.75 11.8995 3.83611 12.1073 3.98938 12.2606C4.14266 12.4139 4.35054 12.5 4.56731 12.5H5.28846C5.63364 12.5 5.91346 12.7798 5.91346 13.125C5.91346 13.4702 5.63364 13.75 5.28846 13.75H4.56731C4.01902 13.75 3.4932 13.5322 3.1055 13.1445C2.7178 12.7568 2.5 12.231 2.5 11.6827V5.19231C2.5 4.64402 2.7178 4.1182 3.1055 3.7305C3.4932 3.3428 4.01902 3.125 4.56731 3.125H11.0577C11.606 3.125 12.1318 3.3428 12.5195 3.7305C12.9072 4.1182 13.125 4.64402 13.125 5.19231V5.91346C13.125 6.25864 12.8452 6.53846 12.5 6.53846C12.1548 6.53846 11.875 6.25864 11.875 5.91346V5.19231C11.875 4.97554 11.7889 4.76766 11.6356 4.61438C11.4823 4.46111 11.2745 4.375 11.0577 4.375H4.56731Z" fill="#6320E9")
          | Copiar código de barras

  .pageSuccess__blockDescription.nps
    NPS(:name="voucherRecipient.name" :email="voucherRecipient.email")

  .pageSuccess__blockDescription
    h1.pageSuccess__text--title Resumo da compra

    template(v-if="promoCode")
      .pageSuccess__valuesInfo
        p Valor do plano:
        p #[b {{ olderTotalValue | currency }}]
      .pageSuccess__valuesInfo
        p Cupom: {{ promoCode }}
        p #[b - {{ (olderTotalValue - amount).toFixed(2) | currency }}]

    div(:class="['pageSuccess__valuesTotal', { 'pageSuccess__valuesTotal--border-top': promoCode }]")
      p Valor total:
      p #[b {{ amount | currency }}]

  .pageSuccess__blockDescription
    .pageSuccess__valuesInfo
      .pageSuccess__valuesInfo--name
        svg(name="location-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M23.1 5.9C21.2 4 18.7 3 16 3C13.3 3 10.8 4 8.9 5.9C7 7.8 6 10.3 6 13.1C6 17.4 8.2 22.2 12.6 27.3L13 27.7C13.8 28.6 14.8 29 15.9 29C17 29 18 28.6 18.9 27.7L19 27.6C23.6 22.3 26 17.4 26 13C26 10.3 25 7.8 23.1 5.9ZM17.5 26.3C16.5 27.2 15.2 27.2 14.5 26.3L14.1 26C10.1 21.2 8 16.9 8 13.1C8 10.9 8.8 8.9 10.3 7.4C11.8 5.8 13.8 5 16 5C18.2 5 20.2 5.8 21.7 7.3C23.2 8.8 24 10.8 24 13C24 17 21.8 21.4 17.5 26.3ZM16 8C13.8 8 12 9.8 12 12C12 14.2 13.8 16 16 16C18.2 16 20 14.2 20 12C20 9.8 18.2 8 16 8ZM16 14C14.9 14 14 13.1 14 12C14 10.9 14.9 10 16 10C17.1 10 18 10.9 18 12C18 13.1 17.1 14 16 14Z" fill="#6320E9")
        h2.pageSuccess__blockDescription--title {{ destinationLabel }}

  .pageSuccess__quotationDetails
    .pageSuccess__valuesBlockInfo
      .pageSuccess__valuesInfo--details
        svg(name="passengers-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z" fill="#6320E9")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M23 13C25.2091 13 27 11.2091 27 9C27 6.79086 25.2091 5 23 5C20.7909 5 19 6.79086 19 9C19 11.2091 20.7909 13 23 13ZM23 7C24.1046 7 25 7.89543 25 9C25 10.1046 24.1046 11 23 11C21.8954 11 21 10.1046 21 9C21 7.89543 21.8954 7 23 7Z" fill="#6320E9")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 18C6.49014 18 2.00014 21.81 2.00014 26.5C1.99019 26.6965 1.99019 26.8935 2.00014 27.09C2.04685 27.6069 2.48118 28.0021 3.00014 28H21.0001C21.5191 28.0021 21.9534 27.6069 22.0001 27.09C22.0101 26.8935 22.0101 26.6965 22.0001 26.5C22.0001 21.81 17.5101 18 12.0001 18ZM4.00014 26C4.32014 22.65 7.78014 20 12.0001 20C16.2201 20 19.6601 22.65 20.0001 26H4.00014Z" fill="#6320E9")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M22.5501 14C20.5721 13.9957 18.676 14.7888 17.2901 16.2C16.9007 16.5921 16.903 17.2257 17.2951 17.615C17.6872 18.0044 18.3207 18.0021 18.7101 17.61C19.7208 16.5778 21.1054 15.9973 22.5501 16C25.3835 16.014 27.7425 18.1783 28.0001 21H23.3901C22.8378 21 22.3901 21.4477 22.3901 22C22.3901 22.5523 22.8378 23 23.3901 23H29.0001C29.5261 23.0013 29.9633 22.5948 30.0001 22.07C30.0001 21.91 30.0001 21.73 30.0001 21.56C30.0278 17.4162 26.6939 14.033 22.5501 14Z" fill="#6320E9")
        h2.pageSuccess__blockDescription--title Passageiros:
          span.cardInsuranceDetails__list__item__value(v-if="!!inputedAgePassengers" v-html="inputedAgePassengers")

    .pageSuccess__valuesBlockInfo
      .pageSuccess__valuesInfo--details
        svg(name="coverage-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 26" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M19.6 4.50078C19.3 4.20078 18.9 4.00078 18.6 4.10078C17.3 4.10078 15.9 3.70078 14.7 3.10078C13.4 2.50078 12.2 1.60078 11.2 0.500781C10.6 -0.0992188 9.6 -0.0992188 9 0.500781C8.1 1.60078 7 2.40078 5.8 3.00078C4.5 3.70078 3.1 4.00078 1.6 4.10078C1.2 4.10078 0.8 4.30078 0.5 4.60078C0.1 4.80078 0 5.20078 0 5.60078V15.6008C0 18.5008 1.5 21.2008 3.8 22.7008L8.7 25.7008C9.1 25.9008 9.5 26.0008 9.9 26.0008C10.3 26.0008 10.7 25.9008 11.1 25.7008L16.1 22.7008C18.5 21.3008 20 18.6008 20 15.6008V5.60078C20 5.20078 19.9 4.80078 19.6 4.50078ZM18 15.6008C18 17.8008 16.9 19.9008 15.1 21.0008L10.1 24.0008H9.8L4.9 21.0008C3.1 19.8008 2 17.8008 2 15.6008V6.00078C3.6 5.90078 5.2 5.50078 6.5 4.70078C7.9 4.20078 9 3.30078 10 2.30078C11.1 3.40078 12.3 4.30078 13.7 4.90078C15 5.60078 16.5 6.00078 18 6.10078V15.6008ZM10 8.00078C10.6 8.00078 11 8.40078 11 9.00078V12.0008H14C14.6 12.0008 15 12.4008 15 13.0008C15 13.6008 14.6 14.0008 14 14.0008H11V17.0008C11 17.6008 10.6 18.0008 10 18.0008C9.4 18.0008 9 17.6008 9 17.0008V14.0008H6C5.4 14.0008 5 13.6008 5 13.0008C5 12.4008 5.4 12.0008 6 12.0008H9V9.00078C9 8.40078 9.4 8.00078 10 8.00078Z" fill="#6320E9")
        h2.pageSuccess__blockDescription--title Cobertura: #[p.pageSuccess__blockDescription--coverage {{ planSelect.packageLabel }} / pessoa]

    .pageSuccess__valuesBlockInfo
      .pageSuccess__valuesInfo--details
        svg(name="calendar-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M25 6H23V5C23 4.4 22.6 4 22 4C21.4 4 21 4.4 21 5V6H11V5C11 4.4 10.6 4 10 4C9.4 4 9 4.4 9 5V6H7C5.3 6 4 7.3 4 9V25C4 26.7 5.3 28 7 28H25C26.7 28 28 26.7 28 25V9C28 7.3 26.7 6 25 6ZM7 8H9V9C9 9.6 9.4 10 10 10C10.6 10 11 9.6 11 9V8H21V9C21 9.6 21.4 10 22 10C22.6 10 23 9.6 23 9V8H25C25.6 8 26 8.4 26 9V13H6V9C6 8.4 6.4 8 7 8ZM7 26H25C25.6 26 26 25.6 26 25V15H6V25C6 25.6 6.4 26 7 26ZM11 17V19H9V17H11ZM17 17H15V19H17V17ZM23 17V19H21V17H23ZM11 24V22H9V24H11ZM15 22H17V24H15V22ZM23 24V22H21V24H23Z" fill="#6320E9")
        h2.pageSuccess__blockDescription--title Vigência: #[p.pageSuccess__blockDescription--travel-date {{ initialDate | date8601 }} ~ {{ endDate | date8601 }}]

    .pageSuccess__valuesBlockInfo(v-if="planSelect.liveloPoints")
      .pageSuccess__valuesInfo--details
        svg(name="livelo-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M12.6385 6.45143C12.8773 6.15971 13.5171 5.45983 14.6015 5.14812C14.8232 5.08437 15.4462 4.92688 16.2373 5.03951C16.6003 5.09121 17.6539 5.25673 18.4184 6.12561C18.5864 6.31654 18.6759 6.47001 18.8546 6.77726C19.3781 7.67731 19.6073 8.57605 19.7271 9.05806C19.7388 9.10552 19.8523 9.56375 20.0542 10.1442C20.1774 10.4981 20.246 10.6459 20.3814 10.7958C20.6085 11.047 20.9087 11.1767 21.0357 11.2303C21.189 11.2949 21.31 11.3254 21.3629 11.3389C21.3629 11.3389 21.7522 11.4373 22.8897 11.7733C23.4276 11.9322 23.9369 12.0861 24.5255 12.425C24.813 12.5904 25.0374 12.7218 25.2889 12.968C25.7476 13.4172 25.9514 13.9111 26.0523 14.1627C26.1137 14.316 26.2085 14.5806 26.2704 14.923C26.3793 15.5259 26.325 16.0309 26.2704 16.3349C26.1361 17.0816 25.823 17.5941 25.7251 17.7468C25.5536 18.0144 25.1056 18.6383 24.3074 19.0501C24.1067 19.1536 23.8827 19.2278 23.4349 19.376C22.9715 19.5293 22.5154 19.6803 21.9082 19.8104C21.7194 19.8509 21.2912 19.9375 20.9267 20.1362C20.7566 20.229 20.6267 20.3317 20.5995 20.3535C20.5167 20.4196 20.3877 20.524 20.2723 20.6793C20.15 20.844 20.0935 20.9978 20.0542 21.1137C19.8692 21.6598 19.7609 22.2401 19.618 22.7429C19.5644 22.9319 19.428 23.3869 19.1818 23.9376C19.0756 24.175 18.989 24.3686 18.8546 24.5892C18.7627 24.7401 18.4258 25.2691 17.8731 25.6753C16.9126 26.3812 15.8081 26.343 15.4739 26.327C15.12 26.3099 14.1331 26.2647 13.2928 25.5667C12.7437 25.1107 12.4963 24.5747 12.2023 23.9376C12.0542 23.6165 11.7309 22.8459 11.5479 22.0912C11.4449 21.6659 11.3701 21.4819 11.2208 21.1137C11.1139 20.8502 11.0601 20.7582 11.0027 20.6793C10.7616 20.3488 10.4239 20.2091 10.2393 20.1362C9.55549 19.8663 9.12385 19.7823 8.49438 19.5932C7.58715 19.3207 7.11909 19.0853 6.85856 18.9415C6.52594 18.7581 6.33509 18.6152 6.20422 18.5071C5.73158 18.1164 5.49013 17.7208 5.44084 17.6382C5.34541 17.4783 5.20986 17.2191 5.11367 16.8779C4.98717 16.4292 4.99546 16.0755 5.00462 15.6832C5.00942 15.4779 5.01901 15.1402 5.11367 14.7058C5.1549 14.5164 5.24345 14.1089 5.44084 13.7283C5.96583 12.7153 7.05911 12.2799 7.51289 12.0991C7.79076 11.9885 8.12076 11.8876 8.49438 11.7733C9.34316 11.5137 9.58494 11.4475 9.58494 11.4475C9.7085 11.4136 9.94166 11.3507 10.2393 11.2303C10.435 11.151 10.5506 11.1034 10.6755 11.013C10.869 10.873 10.9898 10.6992 11.1117 10.47C11.4207 9.88914 11.5946 9.17949 11.657 8.94945C11.9783 7.76648 12.0849 7.42458 12.3113 6.99448C12.4354 6.75891 12.5548 6.57362 12.6385 6.45143Z" stroke="#6320E9" stroke-width="2")
        h2.pageSuccess__blockDescription--title {{ planSelect.liveloPoints }} pontos Livelo

    .pageSuccess__valuesBlockInfo(v-if="planSelect.includeChip")
      .pageSuccess__valuesInfo--details
        img(src="~@/assets/icons/sim-card.svg" width="32" height="32")
        h2.pageSuccess__blockDescription--title 1 Chip digital eSIM

  div.ciclicCellphoneCTA
    CellphoneCTA

  div.ciclicCellphoneModal
    CellphoneModal
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { date8601, document, currency, points } from '@/filters'
import NPS from '@/components/NPS.vue'
import CellphoneCTA from '@/components/CellphoneCTA.vue'
import CellphoneModal from '@/components/CellphoneModal.vue'

export default {
  name: 'BankSlip',
  components: {
    NPS,
    CellphoneCTA,
    CellphoneModal
  },
  data () {
    return {
      isCopy: false
    }
  },
  filters: {
    currency,
    date8601,
    document,
    points
  },
  computed: {
    ...mapState('travelSetup', ['theme']),
    ...mapGetters('quotation', ['destination', 'totalNumberOfPassengers', 'selectedCovidCovers']),
    ...mapState('payment', [
      'url',
      'amount',
      'promoCode',
      'digitableLine'
    ]),
    ...mapState('quotation', [
      'initialDate',
      'endDate',
      'result',
      'numberOfPassengersFourtyYears',
      'numberOfPassengersSixtyFourYears',
      'numberOfPassengersSeventyFiveYears',
      'numberOfPassengersEightyFiveYears',
      'numberOfPassengersNinetyNineYears',
      'selectedQuote',
      'countriesSelected',
      'destinationId'
    ]),
    ...mapState('user', ['passengers', 'voucherRecipient']),
    ...mapState('additional', ['pcr']),
    destinationLabel () {
      return /Y(30|15)/.test(this.destinationId)
        ? `Multi Trip ${this.destinationId.slice(-2)}`
        : this.formatCountriesLabel()
    },
    planSelect () {
      return this.result[this.selectedQuote]
    },
    headerText () {
      return this.planSelect.includeChip
        ? `Após o débito em nosso sistema, enviaremos para o e-mail <b>${this.voucherRecipient.email}</b> dois e-mails diferentes: um para fazer download do bilhete e outro com o passo a passo para ativação do seu chip eSIM. Em caso de não pagamento do boleto, a compra será cancelada.`
        : `Após o débito em nosso sistema, enviaremos um e-mail para <b>${this.voucherRecipient.email}</b> com os detalhes do serviço contratado. Em caso de não pagamento do boleto, a compra será cancelada.`
    },
    olderTotalValue () {
      const key = Object.keys(this.result).find(uuid => uuid === this.selectedQuote)

      return this.result[key].olderTotalValue
    },
    inputedAgePassengers () {
      const passengers = [
        {
          checked: this.numberOfPassengersFourtyYears,
          returnString: `<b>${this.numberOfPassengersFourtyYears}</b> até 40 anos`
        }, {
          checked: this.numberOfPassengersSixtyFourYears,
          returnString: `<b>${this.numberOfPassengersSixtyFourYears}</b> de 41 a 64 anos`
        }, {
          checked: this.numberOfPassengersSeventyFiveYears,
          returnString: `<b>${this.numberOfPassengersSeventyFiveYears}</b> de 65 a 75 anos`
        }, {
          checked: this.numberOfPassengersEightyFiveYears,
          returnString: `<b>${this.numberOfPassengersEightyFiveYears}</b> de 76 a 85 anos`
        }, {
          checked: this.numberOfPassengersNinetyNineYears,
          returnString: `<b>${this.numberOfPassengersNinetyNineYears}</b> de 86 a 99 anos`
        }
      ]

      return passengers.filter(obj => obj.checked).map(({ returnString }) => returnString).join(' - ')
    },
    showChipBanner () {
      return (this.destinationId !== 'BR')
    }
  },
  methods: {
    formatCountriesLabel () {
      const countriesSelected = this.countriesSelected.map(({ label }) => label)

      if (!countriesSelected) return false
      if (countriesSelected.length === 1) return `${countriesSelected[0]}`
      if (countriesSelected.length <= 3) {
        return `${countriesSelected.slice(0, -1).join(', ')} e ${countriesSelected.slice(-1)}`
      }

      return `${countriesSelected[0]}, ${countriesSelected[1]}, ${countriesSelected[2]} e mais ${countriesSelected.length - 3} ${countriesSelected.length === 4 ? 'país' : 'países'}`
    },
    showToast (icon, msg) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      })

      Toast.fire({ icon, title: msg })
    },
    clickToCopy (text, action) {
      const actions = {
        bankSlipCode: ' O código do Boleto foi copiado para sua área de transferência.'
      }

      this.showToast('success', actions[action])
      return navigator.clipboard.writeText(text)
    }
  }
}
</script>

<style lang="scss">
.pageSuccess__bankSlip-btns {
  flex-flow: wrap;
  gap: 16px;

  @media screen and (max-width: 598px) {
    margin-top: 16px;
  }
}
.ciclicCellphoneCTA {
  max-width: 945px;
  width: 100%;
  margin: 0 auto 20px auto;
}
</style>
